/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable default-case */
/* eslint-disable no-unreachable */
import { CustomImage, CustomPageHeader, Text } from '@src/components';
import { Steps } from 'antd';
import CardInformation from './cardInformation';
import Payment from './payment';
import OrderSummary from './orderSummary';
import Completed from './Completed';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import {cardOrdersUpdate, getCardOrders, getCurrentCardOrder, prevStep, reset} from '@src/store/slice/cardOrderSlice';
import iconFinish from '@src/assets/icons/icon-done.svg';
import '@src/styles/cardOrder/cardOrders.scss';
import { resetDetail } from '@src/store/slice/cardOrderDetailtsSlice';
import { useLocation } from 'react-router-dom';
import {handleAuthStatus, isCreditCardUser} from '@src/utils/utils';

const { Step } = Steps;

const steps = [
  {
    title: <Text t="cardInformation" />,
    content: CardInformation,
    key: 'cardInformation',
  },
  {
    title: <Text t="orderSummary" />,
    content: OrderSummary,
    key: 'orderSummary',
  },
  {
    title: <Text t="payment" />,
    content: Payment,
    key: 'payment',
  },
  {
    title: <Text t="approval" />,
    content: Completed,
    key: 'approval',
  },
];
const activeStepKeys = steps.map((item) => item.key);

function getProgressDot() {
  return (iconDot, {index, status}) =>
      status === 'finish' ? <CustomImage src={iconFinish}/> : index + 1;
}

const CardOrders = (props) => {
  const { activeStep, currentCardOrder } = useSelector((state) => state?.cardOrder);
  const { customerVou } = useSelector((state) => state?.customer);
  const { userAuthorizationStatus } = useSelector((state) => state?.user);
  const dispatch = useDispatch();
  const location = useLocation();
  const [_step, _setStep] = useState(steps);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeStep]);

  useEffect(async () => {
    let draftId = props?.match?.params?.cardOrderId;

    if (!draftId && !location.state?.id && !location.state?.pendingApprovalId) {
      await dispatch(getCurrentCardOrder());
    } else if (location?.state?.id) {
      await dispatch(getCardOrders({ id: location?.state?.id }));
    } else if(location?.state?.pendingApprovalId){
      const body = {
        orderStatus: location?.state?.orderStatus,
        pendingApproval: true,
        id: location?.state?.pendingApprovalId,
        invoiceMonth : location?.state?.invoiceMonth,
        cardType : location?.state?.cardType,
        cardActivationDate : location?.state?.cardActivationDate,

      };
      await dispatch(cardOrdersUpdate(body));
      await dispatch(getCardOrders({ id: location?.state?.pendingApprovalId }));
    }else {
      await dispatch(getCardOrders({ id: draftId }));
    }

    return () => {
      dispatch(reset());
      dispatch(resetDetail());
    };
  }, [dispatch, props]);

  const gotoSummaryPage = useCallback(async () => {
    await dispatch(cardOrdersUpdate({ ...currentCardOrder, orderStatus: 10 }));
  }, [currentCardOrder, dispatch]);

  const stepChange = useCallback(
    (current) => {
      if (activeStep - 1 === current) {
        dispatch(prevStep());
      }
    },
    [activeStep, dispatch],
  );

  const StepContent = steps?.find((item) => item.key === activeStepKeys[activeStep])?.content || (
    <> </>
  );
  useEffect(async () => {
    if (customerVou?.pamId <= 0) return;
    if(
        !isCreditCardUser(customerVou) ||
        handleAuthStatus(userAuthorizationStatus || [], 'ApprovalAuthorizationGroup') ||
        handleAuthStatus(userAuthorizationStatus || [], 'PaymentAuthorizationGroup')
    ){
      if (activeStepKeys[activeStep] === 'payment') {
        await gotoSummaryPage();
      }

      const withOutPaymentTab = steps.filter((item) => item.key !== 'payment');
      if (withOutPaymentTab.length === steps.length || withOutPaymentTab.length !== 3) return;
      _setStep([...withOutPaymentTab]);
    }
  }, [customerVou]);

  const changeTab = (key) => {
    if (window.history.pushState) {
      const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?page=${key}`;
      window.history.pushState({ path: newUrl }, '', newUrl);
    }
  };

  const isShowTabName = () => {
    switch (activeStepKeys[activeStep]) {
      case 'cardInformation':
        return changeTab('orderform');
      case 'orderSummary':
        return changeTab('cardordersummary');
      case 'payment':
        return changeTab('cardorderpayment');
      case 'approval':
        return changeTab('cardorderresult');
    }
  };

  useEffect(() => {
    isShowTabName();
  }, [activeStepKeys[activeStep]]);

  return (
    <CustomPageHeader
      data-testid="new-card-order"
      title={<Text t="newCardOrder" />}
      showBreadCrumb
      showHelpButton
      routes={['ticketRestaurantHeader']}
    >
      <div className="row">
        <Steps
          onChange={stepChange}
          current={activeStep}
          className="card-order-steps"
          labelPlacement="vertical"
          progressDot={getProgressDot()}
        >
          {_step.map((item) => (
            <Step key={item.title} title={item.title} disabled={activeStep === 3} />
          ))}
        </Steps>
      </div>
      <StepContent />
    </CustomPageHeader>
  );
};

export default CardOrders;
